import React from 'react';
import { DMRVPageTemplate } from '../components/dmrv/DMRVPageTemplate';
export function CBAMCompliance() {
  return <DMRVPageTemplate id="cbam" tagline="CBAM Carbon Border Adjustment Mechanism | Uganda" headline="Automate Your CBAM Carbon Border Tax Compliance" highlightWord="CBAM Carbon Border Tax" description="Uganda's exporters of cement, steel, fertilizers, and industrial goods face the EU's Carbon Border Adjustment Mechanism. CarbonSafe automates embedded emissions calculations, generates CBAM declarations, and keeps your EU market access intact." badges={['CBAM Ready', 'EU Compliant', 'GHG Protocol', 'Audit-Grade']} heroEmoji="🌍" floatingIcons={[{
    emoji: '🏭',
    position: 'top'
  }, {
    emoji: '📋',
    position: 'right'
  }, {
    emoji: '⚖️',
    position: 'left'
  }]} stats={[{
    value: '$47/ton',
    label: 'EU Carbon Price',
    detail: 'CBAM applies EU ETS carbon pricing to imports from non-pricing jurisdictions'
  }, {
    value: '$2.4B+',
    label: 'Uganda–EU Trade',
    detail: 'Annual bilateral trade value at risk without CBAM compliance'
  }, {
    value: '6',
    label: 'CBAM Sectors',
    detail: 'Cement, steel, aluminium, fertilizers, electricity, and hydrogen'
  }, {
    value: '2026',
    label: 'Full Enforcement',
    detail: 'CBAM financial obligations begin January 2026 for EU importers'
  }]} statsHeadline="The CBAM compliance imperative for Uganda" statsSubtext="The EU's Carbon Border Adjustment Mechanism is reshaping trade economics for Uganda's industrial exporters. Non-compliance means lost market access." howItWorksVerticalName="CBAM compliance" howItWorksSubtext="From embedded emissions data to verified CBAM declarations, four steps to protect your EU market access." howItWorksSteps={[{
    icon: 'FactoryIcon',
    title: 'Map Production Emissions',
    description: 'Identify and quantify all direct and indirect emissions embedded in your exported goods at the production facility level.'
  }, {
    icon: 'BarChart3Icon',
    title: 'Calculate Embedded Carbon',
    description: 'Apply EU-approved methodologies to calculate the specific embedded emissions per tonne of each product exported to the EU.'
  }, {
    icon: 'FileTextIcon',
    title: 'Generate CBAM Report',
    description: 'Auto-generate quarterly CBAM declarations with product-level carbon intensity data ready for EU importer submission.'
  }, {
    icon: 'ShieldCheckIcon',
    title: 'Verify & Submit',
    description: 'Third-party verification of embedded emissions data and direct support for EU importer CBAM certificate obligations.'
  }]} impactTagline="Who CBAM Affects" impactHeadline="Uganda's industrial exporters are in the crosshairs" impactDescription="Any Ugandan company exporting cement, steel products, aluminium, fertilizers, electricity, or hydrogen to the EU must provide verified embedded emissions data to their EU importers. Without it, EU buyers face CBAM certificate costs — and will source elsewhere. CarbonSafe gives you the data they need." impactCtaText="Assess Your CBAM Exposure" impactImageUrl="https://thecooperator.news/wp-content/uploads/2023/10/Uganda-realised-an-increase-in-August-exports-Internet-photo.jpg" impactImageAlt="Industrial facility with emissions monitoring" featuresHeadline="Everything you need for" featuresHighlight="CBAM compliance" featuresSubtext="From embedded emissions calculation to EU importer support — CarbonSafe handles the full CBAM compliance workflow for Ugandan exporters." features={[{
    icon: 'FactoryIcon',
    title: 'Embedded Emissions Calculation',
    description: 'Calculate direct and indirect embedded emissions per tonne of exported goods using EU-approved CBAM methodologies and Uganda-specific emission factors.'
  }, {
    icon: 'FileTextIcon',
    title: 'Quarterly CBAM Declarations',
    description: 'Auto-generate CBAM quarterly reports with product-level carbon intensity data formatted for EU importer submission to the EU CBAM Registry.'
  }, {
    icon: 'ScaleIcon',
    title: 'Carbon Price Benchmarking',
    description: 'Track EU ETS carbon prices and calculate your CBAM liability exposure. Model scenarios to understand the financial impact on your export pricing.'
  }, {
    icon: 'ShieldCheckIcon',
    title: 'Third-Party Verification',
    description: 'Full audit trail and documentation package for accredited CBAM verifiers. Meets EU Commission verification requirements for embedded emissions data.'
  }, {
    icon: 'GlobeIcon',
    title: 'EU Importer Support Package',
    description: 'Provide your EU buyers with verified emissions data in the exact format required for CBAM certificate purchases. Protect your trade relationships.'
  }, {
    icon: 'BarChart3Icon',
    title: 'Multi-Product & Multi-Site',
    description: 'Manage CBAM compliance across multiple production facilities and product lines. Aggregate and disaggregate emissions data by product, site, and shipment.'
  }]} ctaHeadline="Protect your EU market access." ctaHighlight="Start your CBAM compliance today." ctaSubtext="Uganda's industrial exporters can't afford to lose EU buyers over missing emissions data. CarbonSafe makes CBAM compliance fast, accurate, and audit-ready." ctaButtonText="Get CBAM Ready" data-id="element-1199" />;
}